var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 118.2 114",
    style: {
      enableBackground: "new 0 0 118.2 114"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 118.2,
    height: 114
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117,73.6L109.3,56c-0.1-0.3-0.5-0.5-0.8-0.5c-0.4,0-0.7,0.2-0.8,0.6l-7.1,17.8c-1.3,2.7-1.4,5.8-0.2,8.5 c1.1,2.5,3.2,4.5,5.7,5.2c0.9,0.3,1.9,0.4,2.9,0.4c0.2,0,0.4,0,0.6,0c3.1-0.2,5.8-1.9,7.4-4.8C118.6,80.2,118.6,76.5,117,73.6  M115.3,82.3c-1.3,2.3-3.4,3.7-5.9,3.8c-1,0.1-1.9-0.1-2.8-0.3c-2.1-0.6-3.7-2.1-4.6-4.2c-1-2.2-0.9-4.8,0.2-7l6.3-15.9l6.8,15.6 C116.7,76.9,116.7,79.8,115.3,82.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.6,51.4c0-1.3-0.5-2.5-1.5-3.4L64.4,9c0,0-0.1,0-0.1-0.1l-7.8-7.7c-1.2-1.2-2.9-1.6-4.5-1 C49.4,1.1,40.7,4,38.3,4.8c-1,0.3-1.8,1.1-2.1,2.1l-4.6,13.5c-0.5,1.6-0.1,3.3,1.1,4.5l5.5,5.3L2,66.5c-2.6,2.7-2.7,6.9-0.1,9.5 l34.8,35.8c1.3,1.3,3,2.1,4.9,2.1h0.1c1.8,0,3.6-0.7,4.9-2l58.5-57.1C106.1,53.9,106.6,52.7,106.6,51.4 M33.9,23.6 c-0.7-0.7-0.9-1.7-0.6-2.6l4.6-13.5c0.2-0.5,0.5-0.8,1-1C41.3,5.7,50,2.8,52.6,2c0.9-0.3,2-0.1,2.7,0.6l5.6,5.5 c-0.6,0.2-1.2,0.5-1.7,1L39.4,28.9L33.9,23.6z M60.4,10.3c0.4-0.4,0.9-0.6,1.3-0.6c0.4,0,0.9,0.2,1.2,0.4l0.2,0.2l0,0l40.7,38.9 c0.3,0.3,0.5,0.6,0.7,1l-93,9.2L60.4,10.3z M103.9,53.5l-58.5,57.1c-1,1-2.3,1.5-3.7,1.5c-1.4,0-2.7-0.6-3.6-1.6L3.2,74.8 c-1.9-2-1.9-5,0-7l6.2-6.2l95.2-9.5C104.6,52.6,104.3,53.1,103.9,53.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/Paint.9c41b296d924f9fddef28b8829644d3c.svg";
export { ForwardRef as ReactComponent };